"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var DealerDetailsSecondaryHeading = function DealerDetailsSecondaryHeading(_ref) {
  var headingText = _ref.headingText,
    theme = _ref.theme;
  return headingText ? /*#__PURE__*/_react["default"].createElement("h2", {
    className: theme.marginTop30 + " " + theme.marginBottom10 + " " + (theme ? theme.headingSix : '')
  }, headingText) : null;
};
var _default = DealerDetailsSecondaryHeading;
exports["default"] = _default;